// @ts-nocheck

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
export const convertDataFromServer = overhaulCalculationMonth => ({
  ...overhaulCalculationMonth,
  cost: convertFromKopToRub(overhaulCalculationMonth.cost)
});
export const convertDataToServer = overhaulCalculationMonth => ({
  ...overhaulCalculationMonth,
  cost: convertFromRubToKop(overhaulCalculationMonth.cost)
});
const overhaulCalculationMonth = new CommonApi('overhaulCalculationMonth', 'Расчет плана кап. ремонтов для месяцев', convertDataToServer, convertDataFromServer);
export default {
  ...overhaulCalculationMonth
};
